import React from 'react';
export function MechanismSection() {
  return <section className="bg-navy-800 py-20 px-4 sm:px-6 lg:px-8" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="bg-navy-700 rounded-2xl p-8 sm:p-12 shadow-2xl border border-gold-500/20 relative overflow-hidden" data-id="element-87">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-88"></div>
          <div className="relative z-10" data-id="element-89">
            <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-gold-500 mb-8 text-center" data-id="element-90">
              Presentamos el Protocolo Alpha-V
            </h2>
            <div className="space-y-6 text-lg text-[#e0e0e0] leading-relaxed" data-id="element-91">
              <p data-id="element-92">
                A diferencia de cualquier programa de fitness, este es un{' '}
                <span className="text-white font-semibold" data-id="element-93">
                  manual de operaciones para tu sistema endocrino
                </span>
                .
              </p>
              <p data-id="element-94">
                No vendemos abdominales ni vanidad.{' '}
                <span className="text-gold-500 font-semibold" data-id="element-95">
                  Vendemos química interna.
                </span>
              </p>
              <p data-id="element-96">
                El Protocolo Alpha-V utiliza biohacks de nutrición específica y
                optimización del sueño para "encender" la señal entre tu cerebro
                y tu producción hormonal, eliminando la proteína que mantiene tu
                testosterona atrapada e inutilizable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}